import React, {
  useEffect
} from 'react'

import { 
  Form,
  Input,
  Col, 
  Row,
  // Space,
} from 'antd';

// import { useNavigate } from "react-router-dom" 
const { Item } = Form;
const { TextArea } = Input;

const CorporateProfileTab = ({memberData}) => {
  const [addForm] = Form.useForm();
  // const navigate = useNavigate() 
  useEffect(() => {
    addForm.setFieldsValue({
      address_1: memberData?.address_1 || '',
      address_2: memberData?.address_2 || '',
      fax: memberData?.fax || '',
      telephone: memberData?.telephone || '',
      certificate_no: memberData?.certificate_no || '',
      email: memberData?.email || '',
      nature_of_business: memberData?.nature_of_business || '',
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [memberData]);
  return (
    <Row className='tab-container custom-padding'>
      <Col span={24}>
        <Form 
          layout="vertical"
          form={addForm} 
        >
          <Row>
              <Col span={12} className='p-2'>
                  <Item
                      label="Address 1"
                      name="address_1"
                  >
                      <Input disabled/>
                  </Item>
              </Col>
              <Col span={12} className='p-2'>
                  <Item
                      label="Address 2"
                      name="address_2"
                  >
                      <Input disabled/>
                  </Item>
              </Col>
          </Row>
          <Row>
              <Col span={12} className='p-2'>
                  <Item
                      label="Fax"
                      name="fax"
                  >
                      <Input disabled/>
                  </Item>
              </Col>
              <Col span={12} className='p-2'>
                  <Item
                      label="Telephone"
                      name="telephone"
                  >
                      <Input disabled/>
                  </Item>
              </Col>
          </Row>
          <Row>
              <Col span={12} className='p-2'>
                  <Item
                      label="Email"
                      name="email"
                  >
                      <Input disabled/>
                  </Item>
              </Col>
              <Col span={12} className='p-2'>
                  <Item
                      label="Certificate Number"
                      name="certificate_no"
                  >
                      <Input disabled/>
                  </Item>
              </Col>
          </Row>
          <Row>
              <Col span={24}>
                  <Item
                      label="Nature of Business"
                      name="nature_of_business"
                  >
                      <TextArea rows={5} disabled/>
                  </Item>
              </Col>
          </Row>
        </Form>
      </Col>
    </Row>
  )
}
export default CorporateProfileTab
